import { defineComponent as _defineComponent } from 'vue'
import * as validation from 'JS/components/blain-form/validation';
import BForm from 'JS/components/blain-form/BForm.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import StepControls from '../StepControls.vue';
import { AutomotiveSchedulerStep, IWorkOrderCustomerInfoValidationErrors } from 'JS/automotive/auto-service-scheduler/types/session';
import {
	BCheckbox,
	BPhoneNumberField,
	BTextField,
} from "Src/js/components/blain-form";
import { computed, nextTick, reactive, ref, watch } from 'vue';
import { useBreakpoints } from 'JS/composables/breakpoint';
import { useGlobalLoader } from 'JS/automotive/auto-service-scheduler/state/global-loader';
import { useOrderStore } from '../../../state/order';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactInformationStep',
  setup(__props) {

const orderStore = useOrderStore();
const contactInfo = computed(() => orderStore.session?.customerInfo);
const { loading } = useGlobalLoader();

const formState = reactive({
	firstName: '',
	lastName: '',
	emailAddress: '',
	phoneNumber: '',
	hasApptTextReminders: false,
	hasPromoTextReminders: false,
});

const errors = ref<IWorkOrderCustomerInfoValidationErrors>({ firstName: '', lastName: '', emailAddress: '', phoneNumber: '' });
function clearError<K extends keyof IWorkOrderCustomerInfoValidationErrors>(key: K) {
	if (errors.value[key]) {
		errors.value[key] = '';
	}
}

function showLoginSideMenu() {
	Blain.Login.showSideMenu('login', true);
}

// once contact info loads from session, setup state. stop watching so that tab change session refresh doesn't overwrite form
const stopWatchingContactInfo = watch(contactInfo, (info) => {
	if (info == null) {
		return;
	}

	formState.firstName = info.firstName;
	formState.lastName = info.lastName;
	formState.emailAddress = info.emailAddress;
	formState.phoneNumber = info.phoneNumber;
	formState.hasApptTextReminders = info.hasApptTextReminders;
	formState.hasPromoTextReminders = info.hasPromoTextReminders;

	nextTick(() => stopWatchingContactInfo());
}, { immediate: true });

async function handleSubmit() {
	if (loading.value) {
		return;
	}

	await orderStore.submitContactInfo(formState);
	if (orderStore.currentStep === AutomotiveSchedulerStep.ContactInfo && orderStore.session?.customerInfo?.errors) {
		errors.value = { ...orderStore.session.customerInfo.errors };
	}
}

const { isMobile } = useBreakpoints();

return { __sfc: true,orderStore, contactInfo, loading, formState, errors, clearError, showLoginSideMenu, stopWatchingContactInfo, handleSubmit, isMobile, validation, BForm, LinkButton, StepControls, AutomotiveSchedulerStep, BCheckbox, BPhoneNumberField, BTextField }
}

})